import React from 'react';
import {
  MDBTable, MDBTableBody, MDBRow, MDBContainer,
} from 'mdbreact';

function CategoryWiseTable({ eventData }) {
  // console.log('Here', eventData);
  if (eventData == null) return <></>;
  const categoryHours = new Array(6).fill(0);
  const minCategoryHours = [30, 30, 10, 20, 0, 0];
  let totalHours = 0;
  eventData.forEach((event) => {
    categoryHours[event.category - 1] += event.hours;
    totalHours += event.hours;
  });
  return (
    <MDBContainer>
      <MDBRow center>
        <MDBTable striped>
          <MDBTableBody>
            <tr align="center">
              <th scope="row">Category</th>
              <td>1</td>
              <td>2</td>
              <td>3</td>
              <td>4</td>
              <td>5</td>
              <td>6</td>
            </tr>
            <tr align="center">
              <th scope="row">Hours Acquired</th>
              <td>{categoryHours[0]}</td>
              <td>{categoryHours[1]}</td>
              <td>{categoryHours[2]}</td>
              <td>{categoryHours[3]}</td>
              <td>{categoryHours[4]}</td>
              <td>{categoryHours[5]}</td>
            </tr>
            <tr align="center">
              <th scope="row">Min Required</th>
              <td>{minCategoryHours[0]}</td>
              <td>{minCategoryHours[1]}</td>
              <td>{minCategoryHours[2]}</td>
              <td>{minCategoryHours[3]}</td>
              <td>{minCategoryHours[4]}</td>
              <td>{minCategoryHours[5]}</td>
            </tr>
          </MDBTableBody>
        </MDBTable>
        <br />
      </MDBRow>
      <div className="d-flex flex-column">
        <div className="p-2 col-example text-center">
          Hours Acquired:&nbsp;
          <strong>{totalHours}</strong>
        </div>
        <div className="p-2 col-example text-center">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Min Required:&nbsp;
          <strong>{120}</strong>
        </div>
      </div>
    </MDBContainer>
  );
}

export default CategoryWiseTable;
